import { IRootState } from '../../../store'
import { IUserState } from '../store/user.types'

export const getUserSelector = (state: IRootState): IUserState => state.user
